import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import jwtAxios from '@nxsys/services/axios';
import {
  GetListGroupingTimesheetsParams,
  GetListGroupingTimesheetsResponse,
  GetListTimesheetsResponse,
  GetListTimesheetsParams,
} from '../type';

const getListTimesheets = createAsyncThunk(
  `/getListTimesheets`,
  async (
    params: GetListTimesheetsParams,
    { rejectWithValue },
  ): Promise<GetListTimesheetsResponse & { queryParams: GetListTimesheetsParams | null }> => {
    try {
      const response = await jwtAxios.get(`${endPoints.timesheet.main}`, {
        params,
      });
      return {
        data: response.data.data,
        salariedEmployees: response.data.salariedEmployees,
        totalDocs: response.data.totalDocs,
        success: response.data.success,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

const getListBureauTimesheets = createAsyncThunk(
  `/getListBureauTimesheets`,
  async (
    params: GetListTimesheetsParams,
    { rejectWithValue },
  ): Promise<GetListTimesheetsResponse & { queryParams: GetListTimesheetsParams | null }> => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.timesheet.bureauTimesheet}`,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        salariedEmployees: response.data.salariedEmployees,
        totalDocs: response.data.totalDocs,
        success: response.data.success,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

const getListGroupingTimesheets = createAsyncThunk(
  `/getListGroupingTimesheets`,
  async (
    params: GetListGroupingTimesheetsParams,
    { rejectWithValue },
  ): Promise<GetListGroupingTimesheetsResponse> => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.timesheet.groupingTimesheets}`,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        success: response.data.success,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

const getListGroupingTimesheetsBureau = createAsyncThunk(
  `/getListGroupingTimesheetsBureau`,
  async (
    params: GetListGroupingTimesheetsParams,
    { rejectWithValue },
  ): Promise<GetListGroupingTimesheetsResponse> => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.timesheet.groupingList}`,
        {
          params,
        },
      );
      return {
        data: response.data.data,
        success: response.data.success,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

export const timesheetActs = {
  getListTimesheets,
  getListBureauTimesheets,
  getListGroupingTimesheets,
  getListGroupingTimesheetsBureau,
};
